import React from 'react';
import BasketballBroadCast from '../../basketball/BroadCast';
import SoccerBroadCast from '../../soccer/BroadCast';
import HockeyBroadCast from '../../hockey/BroadCast';
import VolleyBallBroadCast from '../../volleyball/BroadCast';
import FootBallBroadCast from '../../football/BroadCast';
import BaseballBroadCast from '../../baseball/Broadcast';

const BroadCastWrapper = ({ sportsType, gameData }) => {
  let renderComponent = null;
  switch (sportsType) {
    case 'baseball':
      renderComponent = <BaseballBroadCast gameData={gameData} />;
      break;
    case 'basketball':
      renderComponent = <BasketballBroadCast gameData={gameData} />;
      break;
    case 'soccer':
      renderComponent = <SoccerBroadCast gameData={gameData} />;
      break;
    case 'hockey':
      renderComponent = <HockeyBroadCast gameData={gameData} />;
      break;
    case 'volleyball':
      renderComponent = <VolleyBallBroadCast gameData={gameData} />;
      break;
    case 'football':
      renderComponent = <FootBallBroadCast gameData={gameData} />;
      break;
  }
  return <div>{renderComponent}</div>;
};

export default BroadCastWrapper;
